<ion-app>
  <div>
    <mapfre-app-banner *ngIf="!ctx.isApp"></mapfre-app-banner>
    <mapfre-web-header
      *ngIf="menu.pwaHeaderActive"
      [ngStyle]="{ 'z-index': menu.menuZindex$ | async }"
    ></mapfre-web-header>
  </div>

  <ion-split-pane when="false" contentId="main-content">
    <ion-menu
      deleteIonBackdrop
      class="menu"
      side="start"
      menuId="app-menu"
      contentId="main-content"
      mode="md"
      [swipeGesture]="ctx.isApp && swipeMenuEnabled"
      [ngClass]="{ 'menu-background': menuBackground }"
      (ionWillClose)="menuBackground = false"
      (ionDidClose)="onMenuClick('CLOSE')"
      (ionDidOpen)="menuBackground = true"
      (ionWillOpen)="onMenuClick('OPEN')"
    >
      <app-menu-component #customMenu style="height: 100%"></app-menu-component>
    </ion-menu>

    <ion-router-outlet
      id="main-content"
      [animated]="ctx.isApp"
      [ngClass]="{ 'pwa-safe-area-header': menu.pwaHeaderActive }"
    ></ion-router-outlet>
    <app-genesys-chat *ngIf="showGenesysChat()"></app-genesys-chat>
  </ion-split-pane>
</ion-app>
